<template>
  <div class="doc-web">
    <div ref="card" class="doc-card" :style="{ height: cardHeight + 'px' }">
      <!-- Barre d'outils : site affiché + recharger / nouvel onglet -->
      <div class="doc-bar">
        <span class="doc-bar-ic"><v-icon size="18">mdi-book-open-page-variant-outline</v-icon></span>
        <div class="doc-bar-txt">
          <b>Documentation ACCEN</b>
          <span>{{ host }}</span>
        </div>
        <div class="doc-bar-sp"></div>
        <button type="button" class="doc-btn" title="Recharger la documentation" @click="reload">
          <v-icon size="18">mdi-refresh</v-icon><span class="doc-btn-lbl">Recharger</span>
        </button>
        <a class="doc-btn" :href="url" target="_blank" rel="noopener" title="Ouvrir dans un nouvel onglet">
          <v-icon size="18">mdi-open-in-new</v-icon><span class="doc-btn-lbl">Nouvel onglet</span>
        </a>
      </div>

      <!-- Site de documentation intégré -->
      <div class="doc-frame-wrap">
        <iframe
          :key="frameKey"
          class="doc-frame"
          :src="url"
          title="Documentation ACCEN"
          allow="clipboard-write; fullscreen"
          referrerpolicy="strict-origin-when-cross-origin"
          @load="onLoad"
        ></iframe>

        <!-- Chargement (puis aide si la page tarde à s'afficher) -->
        <div v-if="isLoading" class="doc-loading">
          <v-progress-circular indeterminate color="#3D4ED8" size="42" width="4"></v-progress-circular>
          <div class="doc-loading-title">Chargement de la documentation…</div>
          <div v-if="isSlow" class="doc-loading-sub">
            C'est plus long que d'habitude.
            <a :href="url" target="_blank" rel="noopener">Ouvrir dans un nouvel onglet</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Site de documentation ACCEN affiché dans l'application.
const DOC_URL = "https://documentation.accen.me";

export default {
  data() {
    return {
      url: DOC_URL,
      frameKey: 0,
      isLoading: true,
      isSlow: false,
      cardHeight: 600,
    };
  },
  computed: {
    host() {
      return this.url.replace(/^https?:\/\//, "").replace(/\/$/, "");
    },
  },
  mounted() {
    window.addEventListener("resize", this.computeHeight);
    this.computeHeight();
    setTimeout(this.computeHeight, 150);
    this.startSlowTimer();
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.computeHeight);
    clearTimeout(this.slowTimer);
  },
  methods: {
    // La carte remplit l'écran sous l'en-tête : marge du bas = marge à gauche.
    computeHeight() {
      this.$nextTick(() => {
        const el = this.$refs.card;
        if (!el) return;
        const r = el.getBoundingClientRect();
        const gap = Math.max(8, Math.round(r.left));
        this.cardHeight = Math.max(320, Math.floor(window.innerHeight - r.top - gap));
      });
    },
    startSlowTimer() {
      clearTimeout(this.slowTimer);
      this.isSlow = false;
      this.slowTimer = setTimeout(() => { if (this.isLoading) this.isSlow = true; }, 10000);
    },
    onLoad() {
      this.isLoading = false;
      this.isSlow = false;
      clearTimeout(this.slowTimer);
    },
    reload() {
      this.isLoading = true;
      this.frameKey++; // recrée l'iframe → recharge la page d'accueil de la documentation
      this.startSlowTimer();
    },
  },
};
</script>

<style>
@import "../style.css";
</style>
